import createVueApp from '@phoenix/createVueApp';
import WeboutiqueModal from '@maison/components/organisms/modals/WeboutiqueModal.vue';

const app = createVueApp();
app.component('WeboutiqueModal', WeboutiqueModal);
app.mount('#phoenix-weboutique-modal');
